<template>
  <!-- Dashboard Content
	================================================== -->
  <div class="dashboard-content-container" data-simplebar>
    <div class="dashboard-content-inner">
      <!-- Dashboard Headline -->
      <div class="dashboard-headline">
        <h3>All Applicable Projects</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>All Applicable Projects</li>
          </ul>
        </nav>
      </div>

      <!-- Row -->
      <div class="row">
        <!-- Dashboard Box -->
        <div class="col-xl-12">
          <div class="dashboard-box margin-top-0">
            <!-- Headline -->
            <div class="headline">
              <h3><i class="icon-material-outline-email"></i> {{ totalApplicableProjects }} Applicable Projects</h3>

              <button class="button sort-by ripple-effect-dark button-sliding-icon btn--height" title="Create Project">
                Create Project
                <i class="icon-material-outline-note-add"></i>
              </button>
            </div>

            <div class="content container padding-bottom-60 padding-top-20">
              <ve-table
                :columns="columns"
                :table-data="tableData"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
              ></ve-table>
              <div class="table-pagination">
                <ve-pagination
                  :total="totalApplicableProjects"
                  :page-index="pageIndex"
                  :page-size="pageSize"
                  @on-page-number-change="pageNumberChange"
                  @on-page-size-change="pageSizeChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-footer></app-footer>
    </div>
  </div>
  <!-- Dashboard Content / End -->
</template>

<script>
  /* eslint-disable no-console */
  import { AppFooter } from '../../partials/user-dashboard';
  import { APPLIABLE_PROJECTS } from '../../../core/config/endpoints/projects';
  import { getCall } from '../../../core/services/http.service';
  
  export default {
    name: 'Project',
    components: {
      AppFooter,
    },

    data() {
      return {
        allApplicableProjects: [],

        totalApplicableProjects: 0,
        pageIndex: 1,
        pageSize: 10,
        fixedHeader: true,
        columns: [
          {
            field: '',
            key: '#',
            title: '#',
            align: 'center',
            renderBodyCell: ({ rowIndex }) => {
              return (this.pageIndex - 1) * this.pageSize + rowIndex + 1;
            },
          },
          {
            field: 'title',
            key: 'title',
            title: 'Title',
            align: 'center',
          },
          {
            field: '',
            key: 'action',
            title: 'Action',
            width: '',
            center: 'left',
            // eslint-disable-next-line no-unused-vars
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span>
                  <button
                    class="button text-white bg-success"
                    style="color:#198754; "
                    on-click={() => alert('icon-feather-eye clicked')}>
                    <i class="icon-feather-eye"></i>
                  </button>
                  &nbsp;
                  <button class="button text-white bg-primary" on-click={() => alert('icon-feather-edit clicked')}>
                    <i class="icon-feather-edit"></i>
                  </button>
                  &nbsp;
                  <button class="button text-white bg-danger" on-click={() => alert('icon-feather-trash-2 clicked')}>
                    <i class="icon-feather-trash-2"></i>
                  </button>
                </span>
              );
            },
          },
        ],
      };
    },

    created() {
      this.applicableProjects();
    },

    computed: {
      tableData() {
        const { pageIndex, pageSize } = this;
        return this.allApplicableProjects.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
      },
      // total count
      totalCount() {
        return this.allApplicableProjects.length;
      },
    },

    methods: {
      applicableProjects() {
        this.$store.commit('setIsLoaded', true);
        getCall(APPLIABLE_PROJECTS)
          .then((response) => {
            this.allApplicableProjects = response.data.data.data;
            this.totalApplicableProjects = this.allApplicableProjects.length;
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },

      // page number change
      pageNumberChange(pageIndex) {
        this.pageIndex = pageIndex;
      },
      // page size change
      pageSizeChange(pageSize) {
        this.pageIndex = 1;
        this.pageSize = pageSize;
      },
    },
  };
</script>

<style></style>
